import { Dispatch } from "redux";

import { SearchBody } from "api-client/models/SearchBody";
import { SearchQueryObj } from "types/search";
import { ACTIONS } from "./types";
import store from "config/store";
import { getAuthConfiguration } from "utils/getAuthConfiguration";
import { ZendeskSearchApi } from "api-client/apis/ZendeskSearchApi";

export const search =
    (searchQueryPayload: SearchBody) => async (dispatch: Dispatch) => {
        const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
        const zendeskSearchApi = new ZendeskSearchApi(getAuthConfiguration(apiBaseUrl));
        try {
            dispatch({
                type: ACTIONS.SEARCH_REQUEST,
            });
            const results = await zendeskSearchApi.searchApiSearchzendeskPost({
                    zendeskSearchBody: searchQueryPayload,
                });
            dispatch({
                type: ACTIONS.SEARCH_SUCCESS,
                payload: results,
            });
        } catch (e) {
            dispatch({
                type: ACTIONS.SEARCH_FAILURE,
            });
            throw e;
        }
    };

export const setQuery = (queryObj: SearchQueryObj) => {
    return {
        type: ACTIONS.SET_SEARCH_QUERY,
        queryObj,
    };
};

export const searchMore =
    (searchQueryPayload: SearchBody) => async (dispatch: Dispatch) => {
        const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
        const zendeskSearchApi = new ZendeskSearchApi(getAuthConfiguration(apiBaseUrl));
        try {
            dispatch({
                type: ACTIONS.SEARCH_MORE_REQUEST,
            });
            const results = await zendeskSearchApi.searchApiSearchzendeskPost({
                zendeskSearchBody: searchQueryPayload,
            });
            dispatch({
                type: ACTIONS.SEARCH_MORE_SUCCESS,
                payload: results,
            });
        } catch (e) {
            dispatch({
                type: ACTIONS.SEARCH_MORE_FAILURE,
            });
            throw e;
        }
    };
